import JSONPath from 'jsonpath'
import CryptoJS from 'crypto-js'
import config from '@/config/user.env'

export const applyJsonPath = (data, path, apply) => {
    const paths = JSONPath.parse(path)
    const parentPathParsed = paths.slice(0, -1)
    const parentPath = JSONPath.stringify(parentPathParsed)
    const key = paths.at(-1).expression.value

    const parents = JSONPath.query(data, parentPath)
    for (const parent of parents) {
        apply(parent, key)
    }

    return data
}

export const applyUnencrypt = (res, paths) => {
    for (const path of paths) {
        applyJsonPath(res, path, (parent, key) => {
            if (typeof parent[key] === 'string') {
                // parent[key] = '已解密###: ' + parent[key].toUpperCase()
                const origin = parent[key]
                parent[key] = decryptJavaAES(origin, KEY)
            }
        })
    }
}

export class HttpEncrypt {
    /**
     * @param {import('node_modules/axios/index').AxiosInstance} service
     */
    setup(service) {
        service.interceptors.response.use(response => {
            const encryptedFields = response.headers['x-encrypted-fields']
            if (encryptedFields) {
                const paths = encryptedFields.split(',').filter(a => a)
                applyUnencrypt(response.data, paths)
            }
            return response
        })
    }

    static instance = new HttpEncrypt()
}

// encrypt

const KEY = config.httpFieldsEncryptKey

/**
 * 解密Java AES/ECB加密的数据
 * @param {string} encryptedData - Base64格式的密文
 * @param {string} key - 密钥字符串 (16字节)
 * @returns {string} 解密后的明文
 */
export function decryptJavaAES(encryptedData, key) {
    try {
        // 将密钥转换为CryptoJS需要的WordArray格式
        const keyBytes = CryptoJS.enc.Utf8.parse(key)

        // 执行解密 - ECB模式不需要IV
        const decrypted = CryptoJS.AES.decrypt(encryptedData, keyBytes, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
        })

        // 将解密结果转换为UTF-8字符串
        const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)

        if (!decryptedStr) {
            throw new Error('解密失败，结果为空。请检查密钥或密文是否正确。')
        }

        return decryptedStr
    } catch (error) {
        console.error('解密失败:', error)
        return null
    }
}
